import MuiCheckbox, {
  CheckboxProps as MuiCheckboxProps
} from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";
import CheckboxEnable from "@saleor/icons/checkbox/Checkbox";
import CheckboxChecked from "@saleor/icons/checkbox/CheckboxChecked";
import CheckboxCheckedHover from "@saleor/icons/checkbox/CheckboxCheckedHover";
import CheckboxEnableHover from "@saleor/icons/checkbox/CheckboxHover";
import CheckboxIndeterminate from "@saleor/icons/checkbox/CheckboxIndeterminate";
import { makeStyles } from "@saleor/macaw-ui";
import React, { useState } from "react";

const useStyles = makeStyles(
  theme => ({
    error: {
      color: theme.palette.error.main
    }
  }),
  { name: "Checkbox" }
);

export type CheckboxProps = Omit<
  MuiCheckboxProps,
  "checkedIcon" | "color" | "icon" | "indeterminateIcon" | "classes"
> & {
  disableClickPropagation?: boolean;
  helperText?: string;
  error?: boolean;
};

const Checkbox: React.FC<CheckboxProps> = ({ helperText, error, ...props }) => {
  const { disableClickPropagation, onClick, disabled, ...rest } = props;
  const [isHover, setIsHover] = useState<boolean>(false);
  const classes = useStyles();

  return (
    <>
      <MuiCheckbox
        icon={
          isHover ? (
            <CheckboxEnableHover />
          ) : (
            <CheckboxEnable disable={disabled} />
          )
        }
        checkedIcon={
          isHover ? (
            <CheckboxCheckedHover />
          ) : (
            <CheckboxChecked disable={disabled} />
          )
        }
        indeterminateIcon={<CheckboxIndeterminate />}
        disabled={disabled}
        {...rest}
        onClick={
          disableClickPropagation ? event => event.stopPropagation() : onClick
        }
        onMouseEnter={() => setIsHover(true)}
        onMouseOut={() => setIsHover(false)}
      />
      {helperText && (
        <FormHelperText classes={{ root: error && classes.error }}>
          {helperText}
        </FormHelperText>
      )}
    </>
  );
};
Checkbox.displayName = "Checkbox";
export default Checkbox;
